import { END_POINT } from "constants/apiConstant";
import { apiPost, apiGet } from "../utils/apiUtils";
import axiosClient from "axios-client";

const { MOUSER_ORDER_CREATE, MOUSER_CREATE_CART, MOUSER_ORDER_QUERY, GET_MOUSER_ENVIRONMENT } =
  END_POINT;

export const mouserCreateOrder = async (payload) => {
  const response = await apiPost(MOUSER_ORDER_CREATE, payload);
  return response;
};

export const mouserCreateCart = async (payload) => {
  const response = await apiPost(MOUSER_CREATE_CART, payload);
  return response;
};

export const mouserOrderQuery = async (payload) => {
  const response = await apiPost(MOUSER_ORDER_QUERY, payload);
  return response;
};

export const getMouserEnvironment = async () => {
  const response = await apiGet(GET_MOUSER_ENVIRONMENT);
  console.log("mouser environment", { data: response });
  return response;
};
